import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";
import Format from "../../../helpers/Format";
import { formataData } from "../../../helpers/mesesHelper";

const renderEtapaData = (etapa, dados, tiposEstadoCivil, tiposRegimeBens) => {
  switch (etapa) {
    case 1:
      return (
        <>
          <h6>Número de sócios: {dados.numero_socios}</h6>
          <h6>Celular: {Format.formataCelular(dados.celular)}</h6>
          <h6>
            Link: <a href={dados.link_contrato}>{dados.link_contrato}</a>
          </h6>
          <h6>Data de assinatura: {formataData(dados.data_assinatura)}</h6>
          <h6>Início do serviço: {formataData(dados.inicio_prestacao)}</h6>
          <h6>CNPJ: {dados.cnpj}</h6>
          <h6>Razão social: {dados.razao_social}</h6>
          <h6>Email para contato: {dados.email_empresa}</h6>
          <h6>Mensalidade: {Format.formataValor(dados.mensalidade)}</h6>
        </>
      );
    case 2: {
      const socios = Array.isArray(dados) ? dados : Object.values(dados);

      if (
        !socios.length ||
        !socios.every((socio) => socio && typeof socio === "object")
      ) {
        console.warn("Nenhum sócio válido encontrado:", socios);
        return <h6>Nenhum sócio cadastrado</h6>;
      }

      return socios.map((socio, index) => {
        const estadoCivil =
          tiposEstadoCivil.find(
            (item) => item.chave === socio.dados_pessoais?.estado_civil
          )?.valor || "";
        const regimeBens =
          tiposRegimeBens.find(
            (item) => item.chave === socio.dados_pessoais?.regime_bens
          )?.valor || "";

        return (
          <div key={`socio-${index}`}>
            <h6>Sócio {index + 1}</h6>
            <h6>Nome: {socio.dados_pessoais?.nome || ""}</h6>
            <h6>CPF: {socio.dados_pessoais?.cpf || ""}</h6>
            <h6>Identidade: {socio.dados_pessoais?.identidade || ""}</h6>
            <h6>Expedidor do RG: {socio.dados_pessoais?.expedidor_rg || ""}</h6>
            <h6>Pis: {socio.dados_pessoais?.pis || ""}</h6>
            <h6>
              Data de Nascimento:{" "}
              {formataData(socio.dados_pessoais.data_nascimento) || ""}
            </h6>
            <h6>
              Cidade de Nascimento:{" "}
              {socio.dados_pessoais?.cidade_nascimento || ""}
            </h6>
            <h6>
              UF de Nascimento: {socio.dados_pessoais?.uf_nascimento || ""}
            </h6>
            <h6>Profissão: {socio.dados_pessoais?.profissao || ""}</h6>
            <h6>Estado Civil: {estadoCivil}</h6>
            <h6>
              Celular:{" "}
              {Format.formataCelular(socio.dados_pessoais.celular) || ""}
            </h6>
            <h6>Email: {socio.dados_pessoais?.email || ""}</h6>
            <h6>Regime de bens: {regimeBens}</h6>
            <h6>CEP: {socio.endereco?.cep || ""}</h6>
            <h6>Logradouro: {socio.endereco?.logradouro || ""}</h6>
            <h6>Número: {socio.endereco?.numero || ""}</h6>
            <h6>Complemento: {socio.endereco?.compl || ""}</h6>
            <h6>Bairro: {socio.endereco?.bairro || ""}</h6>
            <h6>Cidade: {socio.endereco?.cidade || ""}</h6>
            <h6>UF: {socio.endereco?.uf || ""}</h6>
            <h6>
              Documento de Identidade:{" "}
              {socio.identidade?.ext
                ? `Arquivo ${socio.identidade.ext.toUpperCase()}`
                : "Não fornecido"}
            </h6>
            <h6>
              Título de Eleitor:{" "}
              {socio.titulo_eleitor?.ext
                ? `Arquivo ${socio.titulo_eleitor.ext.toUpperCase()}`
                : "Não fornecido"}
            </h6>
          </div>
        );
      });
    }
    case 3:
      return (
        <>
          <h6>CEP: {dados.endereco?.cep || ""}</h6>
          <h6>Logradouro: {dados.endereco?.logradouro || ""}</h6>
          <h6>Número: {dados.endereco?.numero || ""}</h6>
          <h6>Complemento: {dados.endereco?.compl || ""}</h6>
          <h6>Bairro: {dados.endereco?.bairro || ""}</h6>
          <h6>Cidade: {dados.endereco?.cidade || ""}</h6>
          <h6>UF: {dados.endereco?.uf || ""}</h6>
          <h6>Código da cidade: {dados.endereco?.cod_cidade || ""}</h6>
        </>
      );
    default:
      return null;
  }
};

function RelatorioMigracaoModal({
  modalHook,
  etapas,
  criarNovoProcesso,
  tiposEstadoCivil,
  tiposRegimeBens,
}) {
  const { relatorioMigracaoModal, setRelatorioMigracaoModal } = modalHook;

  const getEtapaTitle = (etapa) => {
    switch (etapa) {
      case 1:
        return "Contrato";
      case 2:
        return "Cadastro dos sócios";
      case 3:
        return "Dados da empresa";
      default:
        return null;
    }
  };

  const renderEtapas = () => {
    if (!etapas || typeof etapas !== "object") {
      return <div>Erro: Dados das etapas inválidos</div>;
    }

    const etapasArray = Object.values(etapas).sort((a, b) => a.etapa - b.etapa);
    const result = [];

    for (const etapa of etapasArray) {
      result.push(
        <div key={etapa.etapa}>
          <h5>{getEtapaTitle(etapa.etapa)}</h5>
          {etapa.status !== "CONCLUIDA" ? (
            <h6>Em processamento</h6>
          ) : (
            renderEtapaData(
              etapa.etapa,
              etapa.dados,
              tiposEstadoCivil,
              tiposRegimeBens
            )
          )}
          {etapa.etapa < 3 ? <hr /> : null}
        </div>
      );
      if (etapa.status !== "CONCLUIDA") {
        break;
      }
    }

    return result;
  };

  return (
    <CommonModal
      title="Relatório do processo de migração"
      is_open_modal={relatorioMigracaoModal}
      set_is_open_modal={setRelatorioMigracaoModal}
      size="xl"
      buttons={
        <CommonButton
          key={`novo-processo`}
          color="success"
          onClick={criarNovoProcesso}
        >
          Exportar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-12 px-3 py-3">{renderEtapas()}</div>
      </div>
    </CommonModal>
  );
}

RelatorioMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    relatorioMigracaoModal: PropTypes.bool.isRequired,
    setRelatorioMigracaoModal: PropTypes.func.isRequired,
  }).isRequired,
  criarNovoProcesso: PropTypes.func.isRequired,
  etapas: PropTypes.object.isRequired,
  tiposEstadoCivil: PropTypes.object.isRequired,
  tiposRegimeBens: PropTypes.object.isRequired,
};

export default RelatorioMigracaoModal;
